import {useState, useEffect, useContext} from 'react';

import {ICompany} from '../shared/types/company.types';

import {useDebounce} from './useDebounce';

import {CompanyService} from '../api/services/company.service';
import {EventBusContext} from '../providers/EventBus';

const SIZE_FOR_TOTAL = 1;
const EMPTY_RESPONSE = {data: {content: []}};

interface Props {
  fullSize?: boolean;
  keyWord?: string;
}

export const useSearchCompanies = (props?: Props) => {
  const [searchTerm, setSearchTerm] = useState(props?.keyWord ?? '');
  const debouncedSearch = useDebounce(searchTerm, 500);
  const [data, setData] = useState<ICompany[]>([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const {bus} = useContext(EventBusContext);

  const defaultSpec = {
    keyWord: debouncedSearch,
  };

  const getCompaniesSize = async () => {
    if (!props?.fullSize) return 10;
    try {
      const {data} = await CompanyService.getAll({spec: {...defaultSpec, size: SIZE_FOR_TOTAL}});
      return data.totalElements;
    } catch {
      return 10;
    }
  };

  useEffect(() => {
    if (searchLoading) return;
    setSearchLoading(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  useEffect(() => {
    (async () => {
      try {
        const size = await getCompaniesSize();
        const res = size ? await CompanyService.getAll({spec: {...defaultSpec, size}}) : EMPTY_RESPONSE;
        setSearchLoading(false);
        setData(res.data.content);
      } catch (err) {
        bus?.emit('error', [err]);
        setSearchLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearch]);

  const handleSearch = (value: string) => {
    setSearchTerm(value);
  };

  return {handleSearch, data, searchTerm, searchLoading};
};
